import React from 'react';
import './Cali.css'; 

const Neiva = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKNV.pdf" target="_blank" rel="noreferrer">Aeropuerto Benito Salas</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 02</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA2B.pdf" target="_blank" rel="noreferrer">GAXA2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA2B.pdf" target="_blank" rel="noreferrer">VUKT2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA2B.pdf" target="_blank" rel="noreferrer">GAXA2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA2B.pdf" target="_blank" rel="noreferrer">VUKT2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA2B.pdf" target="_blank" rel="noreferrer">NVA4B</a></th>
          </tr>     
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA3A.pdf" target="_blank" rel="noreferrer">GAXA3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA3A.pdf" target="_blank" rel="noreferrer">VUKT2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/NVA2A.pdf" target="_blank" rel="noreferrer">NVA2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/NVA2A.pdf" target="_blank" rel="noreferrer">NVA2C</a></th>
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA3E.pdf" target="_blank" rel="noreferrer">VUKT3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/GAXA3E.pdf" target="_blank" rel="noreferrer">GAXA3E</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 20</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/LIXA2A.pdf" target="_blank" rel="noreferrer">LIXA2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/USAN4L.pdf" target="_blank" rel="noreferrer">USAN4L</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 02</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/VOR02.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 20</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKNV/VOR20.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Neiva;